import { useQuery } from '@tanstack/react-query';
import { matchResultService } from '@core/supabase/services/matchResultService';
import { queryKeys } from '@core/query/queryKeys';
import { useAuth } from '@core/auth/useAuth';

export function useMatchResults(filters?: { jobId?: string; candidateId?: string }) {
  const { user } = useAuth();
  const orgId = user?.orgId ?? '';

  return useQuery({
    queryKey: filters?.jobId
      ? queryKeys.smartMatch.matchResultsByJob(orgId, filters.jobId)
      : filters?.candidateId
      ? queryKeys.smartMatch.matchResultsByCandidate(orgId, filters.candidateId)
      : queryKeys.smartMatch.matchResults(orgId),
    queryFn: () => matchResultService.list(orgId, filters),
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useMatchKPIs() {
  const { user } = useAuth();
  const orgId = user?.orgId ?? '';

  return useQuery({
    queryKey: queryKeys.smartMatch.matchKPIs(orgId),
    queryFn: () => matchResultService.getKPIs(orgId),
    enabled: !!orgId,
    staleTime: 10 * 60 * 1000,
  });
}
